import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import moment from 'moment'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
//import Mock from './mock'
//Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import axios from 'axios';
import echarts from 'echarts'
import '@/assets/iconfont/iconfont.css'

Vue.prototype.axios = axios

//测试版地址
//Vue.prototype.QrCodeUrl = "http://t-baknd.bangbangrobotics.com";
//axios.defaults.baseURL = 'http://t-baknd.bangbangrobotics.com';

//生产版地址
Vue.prototype.QrCodeUrl = "https://baknd.bangbangrobotics.com";
axios.defaults.baseURL = 'https://baknd.bangbangrobotics.com';


Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

//NProgress.configure({ showSpinner: false });


const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    //NProgress.start();
    if (to.path == '/login') {
        sessionStorage.removeItem('user');
    }
    let user = sessionStorage.getItem('user')
    if (!user && to.path != '/login') {
        next({ path: '/login' })
    } else {
        next()
    }
});

//router.afterEach(transition => {
//NProgress.done();
//});


Vue.prototype.dateFormat = function (row, column) {
    if (row[column.property] == "未绑定") {
        return "未绑定"
    } else if (!row[column.property]) {
        return "0"
    } else {
        var date = row[column.property] * 1000
        if (date == undefined) {
            return ""
        } else if (date == 0) {
            return 0
        }
        return moment(date).format("YYYY-MM-DD HH:mm:ss")
    }
}
Vue.prototype.dateFormat2 = function (row, column) {
    if (row[column.property] == "未绑定") {
        return "未绑定"
    } else if (!row[column.property]) {
        return 0
    } else {
        var date = row[column.property] * 1000
        if (date == undefined) {
            return ""
        } else if (date == 0) {
            return 0
        }
        return moment(date).format("YYYY-MM-DD")
    }
}
Vue.prototype.dateFormat3 = function (row, column) {
    if (row[column.property] == "未绑定") {
        return "未绑定"
    } else if (!row[column.property]) {
        return 0
    } else {
        var date = row[column.property] * 1000
        if (date == undefined) {
            return ""
        } else if (date == 0) {
            return 0
        }
        return moment(date).format("YYYY-MM")
    }
}

Vue.prototype.GetDealerList = function (way) {
    let param = {
        token: this.token,
        fields: "id,name",
        perPage: 50
    }
    way(param).then(res => {
        console.log(res)
        this.Dealerlist = res.data.items
//		sessionStorage.setItem("Dealerlist",JSON.stringify(this.Dealerlist));
    }).catch(err => {
        this.$message.error(err.response.data.message)
//		console.log(err)
    })
}


Vue.prototype.GetList = function (way, param) {
    this.listloading = true
    way(param).then(res => {
        console.log(res)
        console.log("这是通用函数")
        this.List = res.data.items
//		console.log('List',this.List)
        for (var i = 0; i < this.List.length; i++) {
            this.List[i].sNumber = i + 1
        }
        console.log('List', this.List)
        this.Pagesize = res.data.meta.perPage
        this.total = res.data.meta.totalCount
        this.listloading = false
    }).catch(err => {
//		console.log(err.response.data.message)
        this.$message.error(err.response.data.message)
        this.List = []
        this.listloading = false
    })
}

Vue.prototype.GetList2 = function (way, param) {
    this.listloading2 = true
    way(param).then(res => {
        console.log(res)
        this.List2 = res.data.items
        this.Pagesize2 = res.data.meta.perPage
        this.total2 = res.data.meta.totalCount
        this.listloading2 = false
    }).catch(err => {
        console.log(res)
        this.$message.error(err.response.data.message)
        this.List2 = []
        this.listloading2 = false
    })
}

Vue.prototype.Del = function (url, met, data) {
    this.axios.delete(url, {
        params: {
            token: this.token,
        }
    }).then(res => {
//					console.log(res)
        if (res.status == "204") {
            this.GetList(met, data)
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
        } else {
            this.$message.error('对不起，请求失败。')
            this.listloading = false
        }
    }).catch(err => {
        this.$message.error(err.response.data.message)
        this.listloading = false
    })
}

Vue.prototype.Put = function (url, para, met, data) {
    this.axios.put(url, para).then(res => {
        if (res.status == "200") {
            this.GetList2(met, data)
            this.$message({
                type: 'success',
                message: '操作成功!'
            });
        } else {
            this.$message.error('对不起，请求失败。')
        }
    }).catch(err => {
        this.$message.error(err.response.data.message)
    })
}

Vue.prototype.Gethigh = function () {
    var container = document.getElementsByClassName('content-container')
    var Cheight = container[0].clientHeight
//				console.log("container[0].clientHeight",container[0].clientHeight)
    var breadcrumb = document.getElementsByClassName('breadcrumb-container')
    var Bheight = breadcrumb[0].offsetHeight
//				console.log("breadcrumb[0].offsetHeight",breadcrumb[0].offsetHeight)
    var uptool = document.getElementsByClassName('uptool')
    var Uheight = uptool[0].offsetHeight
//				console.log("uptool[0].offsetHeight",uptool[0].offsetHeight)
    var downtool = document.getElementsByClassName('downtool')
    var Dheight = downtool[0].offsetHeight
//				console.log("downtool[0].offsetHeight",downtool[0].offsetHeight)
    this.maxHeight = Cheight - Bheight - Uheight - Dheight - 40 - 20 - 20
//				console.log(this.maxHeight)
}

Vue.prototype.DownForSearch = function () {
    var tool = document.getElementsByClassName('uptool')
    var downsearch = document.getElementsByClassName('downsearch')
    var downHTML = downsearch[0].innerHTML
//	console.log(downHTML)
    if (downHTML == "点击下拉") {
        tool[0].classList.add("autoheight")
        tool[0].classList.remove("noheight")
        downsearch[0].innerHTML = "收回"
    } else {
        tool[0].classList.add("noheight")
        tool[0].classList.remove("autoheight")
        downsearch[0].innerHTML = "点击下拉"
    }
}

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js